import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { getValidHtmlAttributes } from '@bibliocommons/utils-html';
import { Checkmark } from '@bibliocommons/base-icons';

import './Checkbox.scss';

function Checkbox(props) {
  const [checked, setChecked] = useState(props.checked);
  const { id, className, dataKey, innerRef, label, name, value, srOnlyLabel } = props;
  const classNames = cn('cp-checkbox', className);

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked, setChecked]);

  function handleChange() {
    setChecked(!checked);
    props.handleChange(!checked, {
      name,
      value
    });
  }

  function renderLabel() {
    const checkboxLabel = <span className="checkbox__label">{label}</span>;

    if (srOnlyLabel) {
      return <ScreenReaderMessage>{checkboxLabel}</ScreenReaderMessage>;
    }

    return checkboxLabel;
  }

  return (
    <label className={classNames} htmlFor={id} ref={innerRef}>
      <input
        {...getValidHtmlAttributes(props, 'input')}
        checked={checked}
        data-key={dataKey}
        type="checkbox"
        className="checkbox__input"
        onChange={handleChange}
      />
      <span className="checkbox__square">
        <Checkmark />
      </span>
      {renderLabel()}
    </label>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataKey: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, ImmutablePropTypes.map]),
  checked: PropTypes.bool,
  srOnlyLabel: PropTypes.bool
};

Checkbox.defaultProps = {
  checked: false,
  handleChange() {},
  disabled: false,
  srOnlyLabel: false
};

export default Checkbox;
